<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="./images/single.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/single-2.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/single-3.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/single-4.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/single-5.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/single-6.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title">快麦<span class="other-color">D30</span>手持终端PDA</div>
                    <div class="sub-title">Android11系统，支持一维、二维扫码</div>
                    <div class="text">
                        CPU：八核主频2.0GHZ<br/>
                        内存：RAM:2GB ROM:16GB<br/>
                        操作系统：Android11<br/>
                        适用场景：大型仓库快速扫码出库、盘点。
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/1.jpg" alt="bg">
                <img src="./images/1-2.png" alt="bg">
                <img src="./images/2.png" alt="bg">
                <img src="./images/3.png" alt="bg">
                <img src="./images/4.png" alt="bg">
                <img src="./images/5.jpg" alt="bg">
            </div>
        </template>
        <div v-else-if="activeIndex===1" class="main_content content-bg">
            <img src="./images/cs.jpeg" alt="detail">
        </div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }
}
</style>
